import styled from '@emotion/styled';
import { css } from '@emotion/core';
import {
	BaseCell,
	BaseHeader,
} from '../../../../flights/overview/ui/list/columns/Column';
import { formatFullDate } from '../../../../../i18n/formatFullDate';
import { Css, Responsive } from '../../../../../ui';
import { Color } from '../../../../../styles/Color';
import { solicitationListHeaderStyles } from './Column.styles';

interface ISolicitationDateDueProps {
	proposalDue?: string;
}

const styles = css`
	display: flex;
	width: 120px;
	max-width: 120px;
	margin-right: ${Css.pxToRem(40)};
	padding: 0;

	@media (${Responsive.getMediaQueryForBreakpoint('tablet')}) {
		margin-right: 0;
		padding-right: 0;
		max-width: 70px;
	}
`;

export const StyledHeader = styled(BaseHeader)`
	${styles}
	${solicitationListHeaderStyles}
	color: ${Color.Neutral6};

	@media (${Responsive.getMediaQueryForBreakpoint('tablet')}) {
		margin-right: 0;
		padding-right: 0;
	}
`;

export const StyledCell = styled(BaseCell)`
	${styles}
	padding: 0;

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		grid-area: dueDate;
	}
`;

const Date = styled.div`
	font-weight: 300;
	font-size: ${Css.pxToRem(14)};
`;

export function Header() {
	return <StyledHeader css={styles}>Date Due</StyledHeader>;
}

export function Cell({ proposalDue }: ISolicitationDateDueProps) {
	const dateValue = proposalDue
		? formatFullDate(proposalDue, 'MM/dd/yyyy - hh:mm a', true)
		: '-';
	return (
		<StyledCell css={styles}>
			<Date>{dateValue}</Date>
		</StyledCell>
	);
}
